// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1To7Q","title":"FrontImage_title__LXOdq"};